import TableCell from "../TableCell";
import DetailRow from "../DetailRow";
import SingleSelect from "../../../Components/SingleSelect";
import MandatoryLabel from "../Components/MandatoryLabel";
import RefDataLabel from "../Components/RefDataLabel";

const Dosage = ({
  data,
  idField,
  editFlag,
  handleMultiSelectFieldChange = () => {},
  enableEdit = false,
}) => {
  const checkEditStatus = (data) => {
    return data["@none"] !== "-";
  };
  return (
    <>
      {idField && (
        <div className="table-responsive">
          <table class="table  mt-2  table-bordered mb-0">
            <thead>
              <tr className="table-light">
                <th style={{ width: "30%" }} scope="col">
                  <MandatoryLabel
                  label={"Internal Label"}
                  required={true}
                />
                </th>
                <th scope="col">Value</th>
                <th scope="col">Min</th>
                <th scope="col">Max</th>
                <th scope="col">Additional Fields</th>
              </tr>
            </thead>
            <tbody>
              {data && (
                <tr>
                  <td>
                   
                    <TableCell
                      enableEdit={true}
                      editFlag={editFlag}
                      data={data.internalLabel ? data.internalLabel : ""}
                      idField={`${idField}.internalLabel["@none"]`}
                    />
                  </td>
                  <td>
                    <TableCell
                      enableEdit={true && checkEditStatus(data.internalLabel)}
                      editFlag={editFlag}
                      data={data.value}
                      idField={`${idField}.value`}
                    />
                  </td>
                  <td>
                    <TableCell
                      enableEdit={true && checkEditStatus(data.internalLabel)}
                      editFlag={editFlag}
                      data={data.min}
                      idField={`${idField}.min`}
                    />
                  </td>
                  <td>
                    <TableCell
                      enableEdit={true && checkEditStatus(data.internalLabel)}
                      editFlag={editFlag}
                      data={data.max}
                      idField={`${idField}.max`}
                    />
                  </td>

                  <td>
                    {data.qualifier && (
                      <DetailRow
                        enableEdit={true && checkEditStatus(data.internalLabel)}
                        editFlag={editFlag}
                        label={"Qualifier"}
                        data={data.qualifier}
                        idField={`${idField}.qualifier["@none"]`}
                        highlight={true}
                        tooltipId={"qualifier"}
                        tooltipInfo={
                          "Any conditional qualifier associated with the quantity"
                        }
                      />
                    )}
  
                    <DetailRow
                      enableEdit={true && checkEditStatus(data.internalLabel)}
                      editFlag={editFlag}
                      label={"Less Than"}
                      data={data.lessThan}
                      idField={`${idField}.lessThan`}
                    />
                    <DetailRow
                      enableEdit={true && checkEditStatus(data.internalLabel)}
                      editFlag={editFlag}
                      label={"Greater Than"}
                      data={data.greaterThan}
                      idField={`${idField}.greaterThan`}
                    />

                    {data.unitOfMeasurement && data.unitOfMeasurement.label && (
                      <>
                        {enableEdit ? (
                          <>
                            <span className="fw-bold">
                            <RefDataLabel
                              label="Unit Of Measurement:"
                              isRefData={true}
                            />
                            </span>
                            <SingleSelect
                              isFormReset={true}
                              cvType={"unit_cv"}
                              fieldName="unitOfMeasurement"
                              enableEdit={
                                enableEdit &&
                                checkEditStatus(data.internalLabel)
                              }
                              fieldType="unitOfMeasurement"
                              handleSingleSelectFieldChange={
                                handleMultiSelectFieldChange
                              }
                              fieldValue={data.unitOfMeasurement.id}
                              fieldId={`${idField}.unitOfMeasurement.id`}
                            />
                          </>
                        ) : (
                          <DetailRow
                            label={
                              <RefDataLabel
                              label="Unit Of Measurement"
                              isRefData={true}
                            />
                            }
                            data={data.unitOfMeasurement.label["@none"]}
                            idField={`${idField}.unitOfMeasurement.label["@none"]`}
                          />
                        )}

                        {data.unitOfMeasurement &&
                          data.unitOfMeasurement.unitLongName && (
                            <DetailRow
                               label={
                                <RefDataLabel
                                label="Unit Long Name"
                                isRefData={true}
                              />
                              }
                              data={data.unitOfMeasurement.unitLongName}
                              idField={`${idField}.unitOfMeasurement.unitLongName`}
                            />
                          )}
                      </>
                    )}
                    {data.unitOfMeasurement &&
                      data.unitOfMeasurement.symbol && (
                        <>
                          {enableEdit ? (
                            <>
                              <span className="fw-bold">
                              <RefDataLabel
                              label="Unit Of Measurement:"
                              isRefData={true}
                            />
                              </span>
                              <SingleSelect
                                isFormReset={true}
                                cvType={"unit_cv"}
                                fieldName="unitOfMeasurement"
                                enableEdit={
                                  enableEdit &&
                                  checkEditStatus(data.internalLabel)
                                }
                                fieldType="unitOfMeasurement"
                                handleSingleSelectFieldChange={
                                  handleMultiSelectFieldChange
                                }
                                fieldValue={data.unitOfMeasurement.id}
                                fieldId={`${idField}.unitOfMeasurement.id`}
                              />
                            </>
                          ) : (
                            <DetailRow
                               label={
                              <RefDataLabel
                              label="Unit Of Measurement"
                              isRefData={true}
                            />
                            }
                              data={data.unitOfMeasurement.symbol["@none"]}
                              idField={`${idField}.unitOfMeasurement.symbol["@none"]`}
                            />
                          )}
                          {data.unitOfMeasurement &&
                            data.unitOfMeasurement.unitLongName && (
                              <DetailRow
                                label={
                                  <RefDataLabel
                                  label="Unit Long Name"
                                  isRefData={true}
                                />
                                }
                                data={
                                  data.unitOfMeasurement.unitLongName["@none"]
                                }
                                highlight={true}
                                tooltipId={"unitLongName"}
                                tooltipInfo={
                                  "The long name of the unit of measurement"
                                }
                                idField={`${idField}.unitOfMeasurement.unitLongName["@none"]`}
                              />
                            )}
                        </>
                      )}
              
                  {data.complexUnitDenominator && (
                    <div className="border rounded p-2 mt-3" style={{ maxHeight: "400px", overflowY: "auto" }}>
                      <h6 className="fw-bold mb-2">
                        <RefDataLabel
                          label="Complex Unit Denominator"
                          isRefData={true}
                        />
                      </h6>

                      <Dosage
                        data={data.complexUnitDenominator}
                        idField={`${idField}.complexUnitDenominator`}
                        editFlag={editFlag}
                        handleMultiSelectFieldChange={handleMultiSelectFieldChange}
                        enableEdit={enableEdit}
                      />
                    </div>

                  )}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};

export default Dosage;
